import { useEffect } from 'react';
import { connect } from 'react-redux';
import { history } from '../../store';
import { LOGIN_ON_FERRARI } from '../../redux/actions/login';
import { getQueryVariable } from '../../utils/query';

const QueryParamsHandler = ({ loginOnFerrari }) => {
  useEffect(() => {
    const code = getQueryVariable('code');
    const state = getQueryVariable('state');

    if (code) {
      loginOnFerrari(code);
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }

    if (state) {
      const path = decodeURIComponent(state);
      setTimeout(() => {
        history.push(path);
      }, 0);
    }
  }, [loginOnFerrari]);

  return null;
};

export default connect(null, (dispatch) => ({
  loginOnFerrari: (code) => dispatch({ type: LOGIN_ON_FERRARI._REQUEST, code }),
}))(QueryParamsHandler);
